/**
 * Why a stored collection is cleared or downloaded again: each is a state the
 * worker does not get out of by syncing the changes. Described in
 * `.claude/skills/h-sw-channels/data-scope.md` ("Self-repair").
 */
export enum CollectionRepairReason {
  /** A download flag left by a worker that was stopped while downloading. */
  downloadingAtStart = 'downloading-at-start',
  /** Downloaded with a positive total, but the table is empty. */
  emptyAfterDownload = 'empty-after-download',
  /** Downloaded for another project than the configured one. */
  ofAnotherProject = 'of-another-project',
  /** The API refused the sync key: the changes since it cannot be synced. */
  invalidSyncKey = 'invalid-sync-key',
}

/** A collection cleared or downloaded again, and why. */
export interface CollectionRepair {
  table: string;
  reason: CollectionRepairReason;
}
